module.exports = __webpack_public_path__ + "static/media/inicio.950f91d5.svg";